import { Component } from '@theme/component';

/**
 * Desktop search bar progressive enhancement.
 * Without JS: native search form submits to the search page.
 * With JS: click / focus opens the predictive search (quick search) modal.
 *
 * @typedef {object} Refs
 * @property {HTMLFormElement} form
 * @property {HTMLInputElement} input
 * @property {HTMLButtonElement} submit
 *
 * @extends {Component<Refs>}
 */
class PhlSearchBar extends Component {
  requiredRefs = ['form', 'input', 'submit'];

  connectedCallback() {
    super.connectedCallback();
    this.classList.add('is-enhanced');
    this.refs.input.setAttribute('readonly', '');
    this.refs.form.addEventListener('submit', this.#onSubmit);
    this.refs.form.addEventListener('click', this.#onActivate);
    this.refs.input.addEventListener('focus', this.#onActivate);
  }

  disconnectedCallback() {
    this.refs.form.removeEventListener('submit', this.#onSubmit);
    this.refs.form.removeEventListener('click', this.#onActivate);
    this.refs.input.removeEventListener('focus', this.#onActivate);
    super.disconnectedCallback();
  }

  /** @param {Event} event */
  #onSubmit = (event) => {
    event.preventDefault();
    this.#openQuickSearch();
  };

  /** @param {Event} event */
  #onActivate = (event) => {
    event.preventDefault();
    this.refs.input.blur();
    this.#openQuickSearch();
  };

  #openQuickSearch() {
    const modal = /** @type {(HTMLElement & { showDialog?: () => void }) | null} */ (
      document.getElementById('search-modal')
    );

    if (typeof modal?.showDialog === 'function') {
      modal.showDialog();
      return;
    }

    // Fallback if modal is unavailable: navigate to the search page.
    this.refs.form.submit();
  }
}

if (!customElements.get('phl-search-bar')) {
  customElements.define('phl-search-bar', PhlSearchBar);
}
